import { A365Named } from '../base/a365Named';
import { Metamodel } from '../base/model';
import { IDataFlowExpression } from '../dataflow/interfaces/IDataFlowExpression';
import { AttributeReference } from './attributereference';
import { IMappingJoinPair } from './mappingdirective';
import { Owned } from '../base/named';
import { Folder } from '../folder/folder';

export enum MappingType {
    DIRECT = 'Direct',
    DERIVED = 'Derived',
    AGGREGATE = 'Aggregate',
    ADVANCED = 'Advanced',
    UNPIVOT = 'Unpivot',
    LOOKUP = 'Lookup',
    SURROGATEKEY = 'SurrogateKey'
}

export interface IUnpivotInfo {
    targetUnpivotKeyAttribute: string;
    sourceUnpivotAttributes: IUnpivotAttribute[];
}

export interface IUnpivotAttribute {
    unpivotKeyValue: string;
    attributeReference: AttributeReference;
}

export interface ILookupInfo {
    entity: string;
    attribute: string;
    joinPairs: IMappingJoinPair[];
}

@Metamodel.model({
    name: 'attributemapping',
    display: ['attributemapping', 'attributemappings'],
    reusable: true,
    referable: true
})
export class AttributeMapping extends A365Named {
    public name: string = '';
    public mappingType: string = MappingType.DIRECT;
    public attributeReference: AttributeReference;
    public attributeReferences: AttributeReference[];
    public expression: IDataFlowExpression;
    public alternateKeys: string[] = [];
    public unpivotInfo: IUnpivotInfo;
    public lookupFrom: ILookupInfo;
    public functionName: string;
    public transformationMethodDisplayName: string;
    public isSystemGenerated: boolean = false;
    public isRecommended: boolean = false;

    constructor(name: string, mappingType?: string) {
        super();
        this.resetMappingInfo();
        this.folder = Owned.create(Folder.MODEL, undefined);
        this.name = name;
        this.mappingType = mappingType;
    }

    public setName(name: string): void {
        this.name = name;
    }

    public setMappingType(mappingType: MappingType): void {
        if (this.mappingType !== mappingType) {
            this.resetMappingInfo();
        }
        this.mappingType = mappingType;
    }

    public resetMappingInfo(): void {
        this.attributeReference = new AttributeReference('', '');
        this.attributeReferences = [];
        this.expression = undefined;
        this.alternateKeys = [];
        this.unpivotInfo = undefined;
        this.functionName = '';
        this.transformationMethodDisplayName = '';
    }

    public setAttributeReference(colName: string, entity: string): void {
        this.attributeReference = new AttributeReference(colName, entity);
    }

    public addAttributeReference(colName: string, entity: string): void {
        this.attributeReferences.push(new AttributeReference(colName, entity));
    }

    public removeAttributeReference(colName: string, entity: string): void {
        this.attributeReferences = this.attributeReferences.filter((attRef) => attRef.name !== colName || attRef.entity !== entity);
    }

    public setExpression(expression: IDataFlowExpression): void {
        this.expression = expression;
    }

    public setFunction(name: string): void {
        this.functionName = name;
    }

    public setTransformationMethodDisplayName(methodName: string): void {
        this.transformationMethodDisplayName = methodName;
    }
}
